import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

export default function Send({className, ...props}) {
  return (
    <div className={cx('icon', className)} {...props}>
      <svg
        width="25"
        height="24"
        viewBox="0 0 25 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M19.834 6.07988L12.168 13.7458L14.5011 19.7452L19.834 6.07988ZM10.7538 12.3316L18.4198 4.66566L4.75438 9.99849L10.7538 12.3316ZM21.1472 1.47424C21.3303 1.42103 21.6988 1.32541 22.0946 1.45763C22.5417 1.607 22.8926 1.95791 23.042 2.40505C23.1742 2.80082 23.0786 3.16928 23.0254 3.35247C22.9674 3.5521 22.8745 3.79002 22.7813 4.02873L16.1639 20.9859C16.0598 21.2527 15.959 21.5111 15.8604 21.7106C15.7751 21.8829 15.5855 22.2493 15.1919 22.4538C14.7578 22.6793 14.241 22.679 13.8072 22.453C13.4139 22.248 13.2246 21.8814 13.1396 21.709C13.0412 21.5094 12.9407 21.2509 12.8369 20.9839L10.227 14.2726L3.55101 11.6764C3.53924 11.6718 3.52748 11.6673 3.51574 11.6627C3.24878 11.5589 2.99024 11.4584 2.79065 11.36C2.61819 11.275 2.25163 11.0858 2.04668 10.6924C1.82067 10.2586 1.82036 9.74184 2.04586 9.30778C2.25035 8.91417 2.61669 8.72448 2.78905 8.63926C2.98853 8.54063 3.24695 8.43982 3.51379 8.33572C3.52552 8.33115 3.53727 8.32656 3.54904 8.32197L20.4709 1.71832C20.7096 1.62512 20.9475 1.53223 21.1472 1.47424Z"
          fill="#768190"
        />
      </svg>
    </div>
  )
}

Send.propTypes = {
  className: PropTypes.string,
}
